const KEY = 'pf-connect-ai-design-review'

export type AiDesignReviewChoice = 'always' | 'never'

/** Read the persisted AI design-review choice; null = "ask each time" (unset/default). */
export function readAiDesignReviewChoice(): AiDesignReviewChoice | null {
  try {
    const v = localStorage.getItem(KEY)
    return v === 'always' || v === 'never' ? v : null
  } catch {
    return null
  }
}

/** Persist the choice; pass null to reset to "ask each time" (removes the key). */
export function writeAiDesignReviewChoice(choice: AiDesignReviewChoice | null): void {
  try {
    if (choice === null) localStorage.removeItem(KEY)
    else localStorage.setItem(KEY, choice)
  } catch {
    /* localStorage unavailable (private mode / SSR) — preference is best-effort */
  }
}
